import { render, staticRenderFns } from "./employeeTurnoverAction.vue?vue&type=template&id=1231e453&scoped=true"
import script from "./employeeTurnoverAction.vue?vue&type=script&lang=js"
export * from "./employeeTurnoverAction.vue?vue&type=script&lang=js"
import style0 from "./employeeTurnoverAction.vue?vue&type=style&index=0&id=1231e453&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1231e453",
  null
  
)

export default component.exports